<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import FilterBadges from '$saga/views/Search/Filters/FilterBadges.svelte';
    import {
        areMainFiltersActive,
        areSecondaryFiltersActive,
        filtersContext,
    } from '$saga/views/Search/store';
</script>

<div
    class={cn(
        'h-fit w-full max-w-[300px] border border-b-0 border-solid border-border-quiet bg-white px-s',
        $filtersContext.hideVerticalBar && 'hidden',
    )}
>
    <div class="flex flex-col gap-m py-m">
        <span class="font-semibold">{trans('search.filter.sidebar.title')}</span
        >
        {#if $areMainFiltersActive || $areSecondaryFiltersActive}
            <FilterBadges />
        {/if}
    </div>
</div>
